var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.66666H12C12.3536 2.66666 12.6928 2.80714 12.9428 3.05719C13.1929 3.30723 13.3333 3.64637 13.3333 3.99999V13.3333C13.3333 13.687 13.1929 14.0261 12.9428 14.2761C12.6928 14.5262 12.3536 14.6667 12 14.6667H4C3.64638 14.6667 3.30724 14.5262 3.05719 14.2761C2.80714 14.0261 2.66667 13.687 2.66667 13.3333V12M5.33333 2.66666H4C3.64638 2.66666 3.30724 2.80714 3.05719 3.05719C2.80714 3.30723 2.66667 3.64637 2.66667 3.99999V6.00004M6.5 11L8.5 9M8.5 9L6.5 6.99999M8.5 9L2 8.99999M6 1.33333H10C10.3682 1.33333 10.6667 1.63181 10.6667 1.99999V3.33333C10.6667 3.70152 10.3682 3.99999 10 3.99999H6C5.63181 3.99999 5.33333 3.70152 5.33333 3.33333V1.99999C5.33333 1.63181 5.63181 1.33333 6 1.33333Z",
    stroke: "#ABBACE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuffer);
export default __webpack_public_path__ + "static/media/buffer.94e6fcb5261f5ca1926d58f42fcdf05a.svg";
export { ForwardRef as ReactComponent };